export function parseMessageData<T>(data: string | undefined): T | null {
  try {
    if (data) {
      return JSON.parse(data) as T;
    }
  } catch {
    return null;
  }
  return null;
}

export function isMessageHidden(data: string | undefined): boolean {
  return parseMessageData<{ hidden?: boolean }>(data)?.hidden === true;
}

export interface MessageTakedownData {
  takedown?: boolean;
  takedown_alert_id?: string | null;
  takedown_actor_role?: string | null;
  takedown_s_tier?: string | null;
  suppress_for_recipient?: boolean;
}

export function getMessageTakedown(
  data: string | undefined,
): MessageTakedownData | null {
  const parsed = parseMessageData<MessageTakedownData>(data);
  return parsed?.takedown ? parsed : null;
}
